export interface TomarListaAsistencia {
  /** null = todavía no se marcó. */
  celula: boolean | null;
  domingo: boolean | null;
}

export interface TomarListaPersona {
  id: string;
  nombre: string;
  apellido: string;
  miLider: string;
  pasarLista: boolean;
  /** En el mock, false = persona de otro líder. La API ya va a filtrar esto. */
  enMiCelula: boolean;
  nacimiento: string | null;
  sexo: string | null;
  asistencia: TomarListaAsistencia;
}

export interface TomarListaLider {
  id: string;
  nombre: string;
  apellido: string;
}

export interface TomarListaContexto {
  celulaName: string;
  abierta: boolean;
  mostrarLider: boolean;
  elegirLider: boolean;
  lideres: TomarListaLider[];
  idLider: string | null;
}

export interface TomarListaCarga {
  contexto: TomarListaContexto;
  personas: TomarListaPersona[];
}

function tieneLider(miLider: string): boolean {
  const texto = miLider.trim().toLowerCase();
  return texto.length > 0 && texto !== 'sin lider';
}

export function personasParaListar(
  personas: TomarListaPersona[],
  soloConLider = false,
): TomarListaPersona[] {
  return personas.filter((persona) => {
    if (persona.pasarLista || persona.miLider.trim().toLowerCase() === 'evadir') {
      return false;
    }
    return !soloConLider || tieneLider(persona.miLider);
  });
}
